<template>
  <div>
    <div class="maintitle">{{title}}</div>
    <el-divider></el-divider>
    <el-row class="text-left" :gutter="10">
      <el-col :span="4">
        <el-input v-model='keyword' size="mini" placeholder="请输入搜索关键字" @keyup.enter.native="srch"></el-input>
      </el-col>
      <el-select v-model='status' size="mini" clear="margin-left" @change="srch" style='width:100px;'>
        <el-option value='shenheing' label='待审核'></el-option>
        <el-option value='shenheend' label='已审核'></el-option>
        <el-option value='all' label='全部'></el-option>
      </el-select>
      <el-cascader v-model="slctdep" :props="{ checkStrictly: true }" :show-all-levels="false" :options="departmentlist" size='mini' placeholder="请选择部门" class="margin-left" clearable @change="changeDep" style='width:150px;'></el-cascader>
      <el-select v-model='slctEmployee' size="mini" class="margin-left" style='width:100px;' clearable>
        <el-option v-for='item in employeeList' :key='item.uuid' :value='item.uuid' :label='item.name' filter :default-first-option='true'></el-option>
      </el-select>
      <el-button type="success" size="mini" @click="srch" class="margin-left">查找</el-button>
    </el-row>
    <el-table :data="list" row-key="id" border :stripe='true'>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="地址">
              <span>{{ props.row.address}}</span>
            </el-form-item>
            <el-form-item label="上次小记时间">
              <span>{{ props.row.xiaojitime }}</span>
            </el-form-item>
            <el-form-item label="下次小记时间">
              <span>{{ props.row.lasttime }}</span>
            </el-form-item>
            <el-form-item label="有效期">
              <span>{{ props.row.outtime }}</span>
            </el-form-item>
            <el-form-item label="报备来源">
              <span>{{ formatSource(props.row.source) }}</span>
            </el-form-item>
            <el-form-item label="意向度">
              <span>{{ formatYixiang(props.row.yixiang) }}</span>
            </el-form-item>
            <el-form-item label="备注">
              <span>{{ props.row.beizhu }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="id" label="报备id" width='80'></el-table-column>
      <el-table-column label="公司名">
        <template slot-scope="scope">
          <span :class='scope.row.danger==1?"text-danger":""'>{{scope.row.company}}</span>
        </template>
      </el-table-column>
      <el-table-column label="联系电话" width='120'>
        <template slot-scope="scope">
          <span v-html='formatTel(scope.row.tel)'></span>
        </template>
      </el-table-column>
      <el-table-column prop="contact" label="联系人" width='80'></el-table-column>
      <el-table-column prop="employee" width='180'>
        <template slot-scope="scope">
          <span v-html='scope.row.employee'></span>
        </template>
      </el-table-column>
      <el-table-column label="报备业务">
        <template slot-scope="scope">
          <span v-html='formatType(scope.row.type)'></span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width='120'>
        <template slot-scope="scope">
          <el-button type='text' @click="shenhe(scope,1)" v-if='scope.row.status==0 || scope.row.status==3'>过</el-button>
          <el-button type='text' @click="del(scope)">删</el-button>
          <el-button type='text' @click="showbeizhu(scope)">备</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    <el-dialog :visible.sync="beizhuDiv" :show-close="false" :close-on-click-modal="false" width="50%">
      <el-form>
        <el-form-item class="text-left" label="备注" :label-width="formLabelWidth">
          <el-input v-model="beizhu"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="beizhuDiv = false;">取 消</el-button>
        <el-button type="primary" @click="subBeizhu">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Template from '../../kaohe/setting/template.vue';
export default {
  data() {
    return {
      list: [], //员工列表
      title: "",
      page: 1,
      total: 0,
      departmentlist: JSON.parse(sessionStorage.getItem("departmentlist")),
      sourcelist: JSON.parse(sessionStorage.getItem("sourcelist")),
      yixianglist: JSON.parse(sessionStorage.getItem("yixianglist")),
      hangyelist: JSON.parse(sessionStorage.getItem("hangyelist")),
      typelist: JSON.parse(sessionStorage.getItem("alltypelist")),
      beizhuDiv: false,
      crntBaobei: "",
      keyword: "",
      slctdep: "",
      beizhu: "",
      status:'shenheing',
      slctEmployee:'',
      employeeList:[],
    };
  },
  methods: {
    srch() {
      this.page = 1;
      this.getlist();
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getlist();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getlist();
    },
    getlist() {
      this.$axios({
        url: this.HOST + "/baobei/baobei/shenhe",
        method: "post",
        data: {
          keyword: this.keyword,
          page: this.page,
          pagesize: this.pagesize,
          slctdep: this.slctdep,
          status:this.status,
          slctEmployee:this.slctEmployee
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.list = res.data.list.data;
          this.total = res.data.list.total;
        }
      });
    },
    changeDep(){
      this.employeeList = [];
      if(this.slctdep.length>0){
        this.$axios({
          url:this.HOST+'/baobei/index/getEmployeeList',
          method:'post',
          data:{
            dep:this.slctdep
          }
        }).then(res=>{
          this.employeeList = res.data.list;
        })
      }
    },
    formatSource(source) {
      for (let item in this.sourcelist) {
        if (this.sourcelist[item].id == source) {
          return this.sourcelist[item].source;
        }
      }
      return "未知";
    },
    formatYixiang(yixiang) {
      for (let item in this.yixianglist) {
        if (this.yixianglist[item].id == yixiang) {
          return this.yixianglist[item].yixiang;
        }
      }
      return "未知";
    },
    formatType(type) {
      let temp = [];
      for (let i in type) {
        for (let item in this.typelist) {
          if (this.typelist[item].id == type[i]) {
            temp.push(this.typelist[item].name);
          }
        }
      }
      return temp.join('<br />');
    },
    formatCompany(row){
      let date = new Date();
      let now = date.getTime();
      date = new Date(row.lasttime);
      let end = date.getTime();
      if((end-now)>86400000*this.warndays){
        return row.company;
      }else{
        return '<p class="text-danger">'+row.company+'</p>';
      }
    },
    formatTel(tel){
      let temp = tel.split(';');
      return temp.join('<br />');
    },
    formatStatus(row){
      for (let item in this.statuslist) {
        if (this.statuslist[item].id == row.status) {
          return this.statuslist[item].status;
        }
      }
      return "未知";
    },
    showbeizhu(scope){
      this.crntBaobei = scope;
      this.beizhu = scope.row.beizhu;
      this.beizhuDiv = true;
    },
    subBeizhu(){
      this.$axios({
        url:this.HOST+'/baobei/manage/addBeizhu',
        method:'post',
        data:{
          id:this.crntBaobei.row.id,
          beizhu:this.beizhu
        }
      }).then(res=>{
        if(res.data.status == 1){
          this.$message({
            type:'success',
            message:res.data.info
          })
          this.beizhuDiv = false;
          this.crntBaobei.row.beizhu = this.beizhu;
        }
      })
    },
    shenhe(scope){
      this.$confirm('确定要通过'+scope.row.name+'关于'+scope.row.company+'的报备吗？本操作不可恢复',{
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$axios({
          url: this.HOST + "/baobei/manage/setStatus",
          method: "post",
          data: {
            id:scope.row.id,
            status:1
          },
        }).then((res) => {
          if (res.data.status == 1) {
            this.$message({
              type: "success",
              message: res.data.info,
            });
            this.list.splice(scope.$index,1);
          }
        });
      });
    },
    //重置菜单编辑对话框内容
    resetFormInfo() {
      for (let item in this.baobeiinfo) {
        this.baobeiinfo[item] = this.tempinfo[item];
      }
    },
    mdfy(scope) {
      this.crntBaobei = scope;
      for (let item in this.baobeiinfo) {
        this.baobeiinfo[item] = scope.row[item];
      }
      this.addDiv = true;
    },
    checkType() {
      if (this.baobeiinfo.type.length > 3) {
        this.$message({
          type: "warning",
          message: "报备业务不能超过3种",
        });
        this.baobeiinfo.type.splice(3, this.baobeiinfo.type.length - 3);
      }
    },
    submdfy() {
      // console.log(this.baobeiinfo);
      // return;
      this.$axios({
        url: this.HOST + "/baobei/baobei/add",
        method: "post",
        data: {
          info: this.baobeiinfo,
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.addDiv = false;
          this.getlist();
        }
      });
    },
    resetpswd(scope) {
      let uuid = scope.row.uuid;
      this.$confirm(
        "确定要重置" + scope.row.name + "的密码吗？本操作不可恢复",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$axios({
          url: this.HOST + "/baobei/employee/resetpswd",
          method: "post",
          data: {
            muuid: uuid,
          },
        }).then((res) => {
          if (res.data.status == 1) {
            this.$alert(
              "用户密码已重置为 " +
                res.data.newpassword +
                " ，请记录后再关闭本对话框，本密码不可重现！",
              "友情提示",
              {
                confirmButtonText: "确定",
              }
            );
          }
        });
      });
    },
    pushGonghai() {
      // let scope = this.crntBaobei;
      this.$confirm(
        "确定要将" + this.crntBaobei.row.company + "踢入公海吗？本操作不可恢复",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$axios({
          url: this.HOST + "/member.baobei/tichu",
          method: "post",
          data: {
            id: this.crntBaobei.row.id,
            yuanyin: this.yuanyin,
          },
        }).then((res) => {
          if (res.data.status == 1) {
            this.$message({
              type: "info",
              message: res.data.info,
            });
            this.list.splice(this.crntBaobei.$index, 1);
            this.tichuDiv = false;
            this.yuanyin = "";
          }
        });
      });
    },
  },
  created: function () {
    this.title = this.$route.meta.title;
    for (let item in this.baobeiinfo) {
      this.tempinfo[item] = this.baobeiinfo[item];
    }
    this.getlist();
  },
};
</script>
<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 120px;
  color: #99a9bf;
  text-align: right !important;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>